import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';

export interface ProgramMenuContext {
  programId: string;
  programName: string;
  items: MenuItem[];
}

/**
 * Service to communicate program menu items between program-frm and account-manager.
 *
 * When a program is being edited:
 * 1. program-frm calls setMenuItems() with its menu items
 * 2. account-manager subscribes to menuItems$ and renders them under the Programs header
 * 3. When user clicks a menu item, account-manager calls the item's command
 * 4. When program-frm is destroyed, it calls clearMenuItems()
 */
@Injectable({
  providedIn: 'root',
})
export class ProgramMenuService {
  private menuContextSubject = new BehaviorSubject<ProgramMenuContext | null>(null);

  /** Observable for the current program's menu context */
  menuContext$ = this.menuContextSubject.asObservable();

  /** Set the menu items for the current program being edited */
  setMenuItems(programId: string, programName: string, items: MenuItem[]) {
    this.menuContextSubject.next({ programId, programName, items });
  }

  /** Clear the menu items (call when leaving program edit) */
  clearMenuItems() {
    this.menuContextSubject.next(null);
  }

  /** Get current menu context synchronously */
  getCurrentContext(): ProgramMenuContext | null {
    return this.menuContextSubject.value;
  }
}
